import { X } from 'lucide-react'
import { Link, useFetcher } from 'react-router'

type AlertItem = {
	id: string
	message: string
	url: string | null
	dismissible: boolean
}

function AlertRow({ alert }: { alert: AlertItem }) {
	const fetcher = useFetcher()

	if (fetcher.state !== 'idle') return null

	const messageNode = alert.url ? (
		alert.url.startsWith('/') ? (
			<Link to={alert.url} className="underline underline-offset-2">
				{alert.message}
			</Link>
		) : (
			<a
				href={alert.url}
				target="_blank"
				rel="noopener noreferrer"
				className="underline underline-offset-2"
			>
				{alert.message}
			</a>
		)
	) : (
		<span>{alert.message}</span>
	)

	return (
		<li role="status">
			<div className="container grid grid-cols-[1fr_auto_1fr] items-center gap-2 py-3 px-4">
				<div aria-hidden="true" />
				<p className="text-center text-sm">{messageNode}</p>
				<div className="flex justify-end">
					{alert.dismissible && (
						<fetcher.Form method="post" action="/resources/alerts/dismiss">
							<input type="hidden" name="alertId" value={alert.id} />
							<button
								type="submit"
								className="h-touch w-touch flex shrink-0 items-center justify-center rounded-md opacity-80 transition-opacity hover:opacity-100"
								aria-label="Fermer l'annonce"
							>
								<X className="h-4 w-4" />
							</button>
						</fetcher.Form>
					)}
				</div>
			</div>
		</li>
	)
}

export function AlertBanner({ alerts }: { alerts: AlertItem[] }) {
	if (alerts.length === 0) return null

	return (
		<aside aria-label="Annonces" className="bg-primary text-primary-foreground">
			<ul className="divide-primary-foreground/10 divide-y">
				{alerts.map((alert) => (
					<AlertRow key={alert.id} alert={alert} />
				))}
			</ul>
		</aside>
	)
}
